import { mobileTextCss, TextProps, textCss } from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

export const WebsiteLanguageSwitcherDropdownItemUi = styled.a<TextProps>`
  display: flex;
  padding-right: 6px;
  gap: 6px;
  align-items: center;
  cursor: pointer;
  min-width: 115px;
  ${textCss};
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileTextCss}
    `} 
  ${p => p.theme.phone} {
    ${mobileTextCss}
  }
  transition: background-color 0.25s ease;

  &:hover {
    background-color: #F1F5F9;
  }  
`
